import { render, staticRenderFns } from "./clientCard.vue?vue&type=template&id=921ab1ba&scoped=true"
import script from "./clientCard.vue?vue&type=script&lang=js"
export * from "./clientCard.vue?vue&type=script&lang=js"
import style0 from "./clientCard.vue?vue&type=style&index=0&id=921ab1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921ab1ba",
  null
  
)

export default component.exports